/* theme.js — comportamiento general: drawers, anuncios, saltos a anclas */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});

  /* ------------------------------------------------------------ drawers */
  var lastFocus = null;
  ONX.openDrawer = function (id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    var ov = document.querySelector('[data-drawer-overlay="' + id + '"]');
    if (ov) ov.classList.add('is-open');
    document.body.classList.add('no-scroll');
    var f = d.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  };
  ONX.closeDrawer = function (d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    var ov = document.querySelector('[data-drawer-overlay="' + d.id + '"]');
    if (ov) ov.classList.remove('is-open');
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); ONX.openDrawer(open.getAttribute('data-drawer-open')); return; }
    var close = e.target.closest('[data-drawer-close]');
    if (close) { ONX.closeDrawer(close.closest('.drawer')); return; }
    var ov = e.target.closest('[data-drawer-overlay]');
    if (ov) { ONX.closeDrawer(document.getElementById(ov.getAttribute('data-drawer-overlay'))); return; }

    // Saltos a cualquier sección: data-scroll-to="reviews" busca #reviews o [data-anchor="reviews"]
    var jump = e.target.closest('[data-scroll-to]');
    if (jump) {
      var id = jump.getAttribute('data-scroll-to');
      var t = id && (document.getElementById(id) || document.querySelector('[data-anchor="' + id + '"]'));
      // "packs": directo al selector de packs (Kaching o Onnexa Bundles); si no hay, al hero
      if (id === 'packs') t = document.querySelector('.kaching-bundles, [data-pbx-root]') || document.getElementById('hero');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(ONX.closeDrawer);
  });

  /* ----------------------------------------------- anuncios rotativos */
  function initAnn(root) {
    (root || document).querySelectorAll('[data-ann-rotate]').forEach(function (r) {
      if (r._annT) clearInterval(r._annT);
      var slides = r.querySelectorAll('.ann__slide');
      if (slides.length < 2) return;
      var i = 0, every = (parseFloat(r.getAttribute('data-ann-rotate')) || 4) * 1000;
      r._annT = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, every);
    });
  }

  /* ---------------------------------------------- dinero en el cliente */
  ONX.money = function (cents) {
    var fmt = ONX.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    function f(d, ts, ds) {
      var p = v.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(0, '.', ',');
      return f(2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  };

  ONX.toast = function (msg) {
    var t = document.getElementById('Toast');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.hidden = true; }, 2600);
  };

  /* ------------------------- cintas que aceleran con la velocidad del scroll */
  // La animación es CSS (barata); aquí solo se cambia su playbackRate.
  var cintas = [], lastY = window.pageYOffset, vel = 0, rafC = null;
  function initCintas() {
    cintas = Array.prototype.map.call(document.querySelectorAll('[data-marquee]'), function (el) {
      var anims = [];
      el.querySelectorAll('.cinta__track, [data-marquee-track]').forEach(function (t) { if (t.getAnimations) anims = anims.concat(t.getAnimations()); });
      return { boost: Number(el.getAttribute('data-boost')) || 0, anims: anims };
    }).filter(function (c) { return c.boost > 0 && c.anims.length; });
  }
  function tickCintas() {
    var y = window.pageYOffset;
    vel = vel * 0.86 + (y - lastY) * 0.14;          // suavizado
    lastY = y;
    var parado = Math.abs(vel) < 0.05;
    cintas.forEach(function (c) {
      // baja: acelera hacia adelante · sube: un tirón hacia atrás
      var rate = 1 + Math.max(-2.4, Math.min(c.boost * 0.9, vel * c.boost * 0.06));
      if (Math.abs(rate) < 0.25) rate = rate < 0 ? -0.25 : 0.25;
      c.anims.forEach(function (a) { a.playbackRate = parado ? 1 : rate; });
    });
    rafC = parado ? null : requestAnimationFrame(tickCintas);
  }
  window.addEventListener('scroll', function () { if (cintas.length && !rafC) rafC = requestAnimationFrame(tickCintas); }, { passive: true });

  /* ------------------------------------- botones magnéticos (solo con mouse) */
  function initMagnets(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('[data-magnet]').forEach(function (b) {
      if (b._mag) return; b._mag = true;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * 0.28, dy = (e.clientY - (r.top + r.height / 2)) * 0.36;
        b.style.translate = dx.toFixed(1) + 'px ' + dy.toFixed(1) + 'px';
      });
      b.addEventListener('mouseleave', function () { b.style.translate = '0 0'; });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initAnn(); initCintas(); initMagnets(); });
  document.addEventListener('shopify:section:load', function (e) { initAnn(e.target); initCintas(); initMagnets(e.target); });
})();
